(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ab-pd2-ultra-card-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ab-pd2-card-slider')) {
    customElements.define('ab-pd2-card-slider', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.abortController) return;

        this.viewport = this.querySelector('[data-pd2-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-pd2-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-pd2-dot]'));
        this.previousButton = this.querySelector('[data-pd2-prev]');
        this.nextButton = this.querySelector('[data-pd2-next]');

        if (!this.viewport || this.slides.length < 2) return;

        this.abortController = new AbortController();
        this.activeIndex = 0;
        this.frame = null;

        const signal = this.abortController.signal;

        this.viewport.addEventListener('scroll', () => this.requestUpdate(), { passive: true, signal });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.activeIndex - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.activeIndex + 1);
          }
        }, { signal });

        this.previousButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1), { signal });
        this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1), { signal });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goTo(index), { signal });
        });

        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-pd2-slide]');
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.goTo(index, false);
        }, { signal });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.requestUpdate());
          this.resizeObserver.observe(this.viewport);
        } else {
          window.addEventListener('resize', () => this.requestUpdate(), { signal });
        }

        this.update();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.resizeObserver?.disconnect();
        this.abortController?.abort();
        this.abortController = null;
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      isCarousel() {
        return window.matchMedia('(max-width: 767px)').matches
          ? this.dataset.mobileMode !== 'grid'
          : this.dataset.desktopMode === 'carousel';
      }

      hasDesktopPeek() {
        return window.matchMedia('(min-width: 768px)').matches &&
          this.dataset.desktopMode === 'carousel' && Number(this.dataset.desktopPeek) > 0;
      }

      slideLeft(slide) {
        const slideBox = slide.getBoundingClientRect();
        const viewportBox = this.viewport.getBoundingClientRect();
        const offset = slideBox.left - viewportBox.left + this.viewport.scrollLeft;
        return this.hasDesktopPeek()
          ? Math.max(0, Math.min(offset, this.viewport.scrollWidth - this.viewport.clientWidth))
          : offset;
      }

      update() {
        if (!this.isCarousel()) {
          this.activeIndex = 0;
          this.updateControls();
          return;
        }

        const currentLeft = this.viewport.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(this.slideLeft(slide) - currentLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.activeIndex = closestIndex;
        this.updateControls();
      }

      updateControls() {
        this.dots.forEach((dot, index) => {
          // Hide duplicate destinations when several cards share the final scroll stop.
          dot.hidden = this.hasDesktopPeek() && index > 0 &&
            Math.abs(this.slideLeft(this.slides[index]) - this.slideLeft(this.slides[index - 1])) < 1;
          const active = index === this.activeIndex;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (this.previousButton) this.previousButton.disabled = this.activeIndex === 0;
        if (this.nextButton) this.nextButton.disabled = this.hasDesktopPeek()
          ? this.slideLeft(this.slides[this.activeIndex]) >= this.viewport.scrollWidth - this.viewport.clientWidth - 1
          : this.activeIndex === this.slides.length - 1;
      }

      goTo(index, animate = true) {
        if (!this.isCarousel()) return;

        const targetIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        const slide = this.slides[targetIndex];
        if (!slide) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollTo({
          left: this.slideLeft(slide),
          behavior: animate && !reducedMotion ? 'smooth' : 'auto'
        });

        this.activeIndex = targetIndex;
        this.updateControls();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-pd2-ultra-feel-hit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pd2-feel-hit')) {
    customElements.define('pd2-feel-hit', class extends HTMLElement {
      connectedCallback() { this.initFrame = requestAnimationFrame(() => this.init()); }
      init() {
        if (this.controller) return;
        this.viewport = this.querySelector('.pd2-feel__viewport');
        this.cards = [...this.querySelectorAll('.pd2-feel__card')];
        this.dots = [...this.querySelectorAll('[data-feel-index]')];
        if (!this.viewport || this.cards.length < 2) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.viewport.addEventListener('scroll', () => this.schedule(), { signal, passive: true });
        this.viewport.addEventListener('keydown', event => {
          if (!matchMedia('(max-width: 767px)').matches) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.go(event.key === 'ArrowRight' ? 1 : 0);
          }
        }, { signal });
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i), { signal }));
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.indexOf(event.target.closest('.pd2-feel__card'));
          if (index >= 0) this.go(index);
        }, { signal });
        this.observer = new ResizeObserver(() => this.schedule()); this.observer.observe(this.viewport);
        this.update();
      }
      go(index) {
        if (!matchMedia('(max-width: 767px)').matches) return;
        const max = this.viewport.scrollWidth - this.viewport.clientWidth;
        this.viewport.scrollTo({ left: index ? max : 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      schedule() {
        cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.update());
      }
      update() {
        const max = this.viewport.scrollWidth - this.viewport.clientWidth;
        const active = max > 0 && this.viewport.scrollLeft > max / 2 ? 1 : 0;
        this.dots.forEach((dot, i) => i === active ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame); cancelAnimationFrame(this.frame);
        this.controller?.abort(); this.controller = null; this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-pd2-ultra-play-modes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pd2-play-modes')) {
  customElements.define('pd2-play-modes', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.controller) return;
      this.viewport = this.querySelector('.pm-viewport');
      this.cards = Array.from(this.querySelectorAll('[data-mode-card]'));
      if (!this.viewport || this.cards.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.controls = this.querySelector('.pm-controls');
      this.dots = Array.from(this.querySelectorAll('[data-mode-index]'));
      this.previous = this.querySelector('[data-mode-previous]');
      this.next = this.querySelector('[data-mode-next]');
      this.previous.addEventListener('click', () => this.go(this.active - 1), options);
      this.next.addEventListener('click', () => this.go(this.active + 1), options);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i), options));
      this.viewport.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = 0; this.update(); });
      }, { ...options, passive: true });
      this.viewport.addEventListener('keydown', event => {
        if (event.target !== this.viewport) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.active + (event.key === 'ArrowRight' ? 1 : -1);
        this.go(index);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-mode-card]');
        const index = this.cards.indexOf(card);
        if (index >= 0) this.go(index, false);
      }, options);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.viewport);
      } else {
        window.addEventListener('resize', () => this.update(), options);
      }
      this.update();
    }
    positions() {
      const first = this.cards[0].getBoundingClientRect().left;
      const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      return this.cards.map(card => Math.min(maximum, Math.max(0, card.getBoundingClientRect().left - first)));
    }
    go(index, smooth = true) {
      const positions = this.positions();
      const target = Math.max(0, Math.min(index, positions.length - 1));
      this.viewport.scrollTo({ left: positions[target], behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
    }
    update() {
      const positions = this.positions();
      const current = this.viewport.scrollLeft;
      this.active = positions.reduce((best, value, i) => Math.abs(value - current) < Math.abs(positions[best] - current) ? i : best, 0);
      this.dots.forEach((dot, i) => { if (i === this.active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      this.previous.disabled = this.active === 0;
      this.next.disabled = this.active === this.cards.length - 1;
      this.controls.hidden = this.viewport.scrollWidth <= this.viewport.clientWidth + 1;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = 0;
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
